import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tagQueryKeys, Tags } from '#api';
import type { TagName } from '#dn-types/host.ts';

export function useDeleteTag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (tagName: TagName) => Tags.deleteTag(tagName),
    onSuccess(data, tagName) {
      queryClient.removeQueries({ queryKey: tagQueryKeys.detail(tagName), exact: true });
      void queryClient.invalidateQueries({ queryKey: tagQueryKeys.maxList });
    },
  });
}
